import React from "react";
import Highlight from "../../../components/Highlight";
import styled from 'styled-components';
import { minDevice } from "../../../Theme";
import List from './components/List';
import { Card } from "@etiquette-ui/misc";
import { TEXT } from "@etiquette-ui/colors";
import { Container } from "../../../GlobalStyles";
import useI18n from '../../../i18n/useI18n';

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 50px 0px 80px 0px;
    color: ${TEXT};

    @media ${minDevice.tablet} { 
        padding: 80px 0px 100px 0px;
    }
`;

const TitleContainer = styled.div`
    flex: 0 0 100%;
    max-width: 100%;
    h2 {
        margin: 0px;
        margin-bottom: 25px;
    }
    @media ${minDevice.ipad} {
        flex: 0 0 25%;
        max-width: 25%;
    }
`;

const ListContainer = styled(Card)`
    flex: 0 0 100%;
    max-width: 100%;
    padding: 20px 15px!important;
    padding-top: 25px!important;

    ul {
        padding: 0px;
        margin: 0px;
    }
    @media ${minDevice.ipad} {
        flex: 0 0 73%;
        max-width: 73%;
        margin-left: 15px;  
        padding: 30px!important;   
        padding-top: 35px!important;
    }

`;


const GreatFeatures = ({ data }) => {
    
    const { translateObject } = useI18n();

    const highlightTitle = {
        en: 'Great',
        es: 'Grandes'
    }

    const title = {
        en: 'features',
        es: 'bondades'
    }
    
    return(
        <Container>
            <Row>
                <TitleContainer data-sal="slide-up" data-sal-easing="ease-in-circ">
                    <h2><Highlight text={translateObject(highlightTitle)} /> {translateObject(title)}</h2>
                </TitleContainer>
                <ListContainer>
                    <ul>
                        {data.features.map(item => <List text={translateObject(item)} />)}
                    </ul>                
                </ListContainer>
            </Row>
        </Container>
    )
};
export default GreatFeatures;